/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
// Import your layout component - adjust the path as needed
import Layout from "./src/layouts"
// Import Tailwind CSS
import "./src/styles/globals.css"

// Wrap all pages with your layout component
// Uncomment and adjust when you're ready to implement layout
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

export const onClientEntry = () => {
  // IntersectionObserver polyfill for older browsers (mainly IE11)
  if (typeof window !== "undefined" && !window.IntersectionObserver) {
    import("intersection-observer").then(() => {
      console.log("IntersectionObserver polyfilled for older browsers")
    })
  }
}

// Optional: Handle route updates for loading states, analytics, etc.
// export const onRouteUpdate = ({ location, prevLocation }) => {
//   // Track page views, update loading states, etc.
// }

// Optional: Handle delayed route updates for slow pages
// export const onRouteUpdateDelayed = () => {
//   // Show loading indicator, etc.
// }
